import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 16, className = "" }) => (
  <div className={`flex items-center gap-0.5 ${className}`} aria-label={`${value} din 5 stele`}>
    {[1, 2, 3, 4, 5].map((i) => {
      const active = i <= Math.round(value);
      return (
        <Star
          key={i}
          className="shrink-0"
          style={{ width: size, height: size }}
          fill={active ? "#f59e0b" : "none"}
          stroke={active ? "#f59e0b" : "#cbd5e1"}
          strokeWidth={1.5}
        />
      );
    })}
  </div>
);
